/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrarytoolformat3Inputs */

const en_medialibrarytoolformat3 = /** @type {(inputs: Medialibrarytoolformat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const de_medialibrarytoolformat3 = /** @type {(inputs: Medialibrarytoolformat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

/**
* | output |
* | --- |
* | "Format" |
*
* @param {Medialibrarytoolformat3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarytoolformat3 = /** @type {((inputs?: Medialibrarytoolformat3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarytoolformat3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarytoolformat3(inputs)
	return de_medialibrarytoolformat3(inputs)
});
export { medialibrarytoolformat3 as "mediaLibraryToolFormat" }